import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    user: {}, 
  },
  mutations: {
    updateUserInfo(state, data) {
      state.user = data;
    }
  },
  actions: {},
  modules: {}
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js